import { useCallback, useContext } from "react";
import { DashboardContext } from "@/components/dashboard-layout";
import { toast } from "sonner";

interface OpenSidebarOptions {
  component: React.ReactNode | null;
  paramKeys: string | string[];
  shouldClose?: boolean;
  permissionCheck?: boolean;
  onPermissionDenied?: () => void;
}

export function useRightSidebarOpen() {
  const dashboardContext = useContext(DashboardContext);

  return useCallback(
    ({
      component,
      paramKeys,
      shouldClose = false,
      permissionCheck = false,
      onPermissionDenied,
    }: OpenSidebarOptions) => {
      // Handle permission denial
      if (permissionCheck) {
        toast.error("You do not have permission to access this page.", {
          id: "permission-denied",
        });
        onPermissionDenied?.();
        return;
      }

      // Close sidebar if needed (e.g., isExact route)
      if (shouldClose) {
        dashboardContext?.setRightSidebar?.(null);
        dashboardContext?.setRightSidebarParamKey?.(undefined);
        return;
      }

      // Open sidebar with component
      dashboardContext?.setRightSidebar?.(component);
      dashboardContext?.setRightSidebarParamKey?.(paramKeys);
    },
    [dashboardContext?.setRightSidebar, dashboardContext?.setRightSidebarParamKey]
  );
}
